<script setup>
import { computed, watch, onMounted, provide } from 'vue';
import { useStore } from 'vuex';
import MessagesView from 'dashboard/components/widgets/conversation/MessagesView.vue';

// Embeds the real inbox conversation UI (message list + reply box) for the
// conversation that created the ticket, so agents can read and reply in place.
// MessagesView is fully driven by the `getSelectedChat` store getter, so we
// load the conversation and mark it active, then render it.
const props = defineProps({
  // Conversation display_id (the dashboard uses display_id as the chat `id`).
  conversationId: { type: [Number, String], default: null },
});

// We are already inside a ticket — hide the reply box's "Create Ticket" action.
provide('hideCreateTicketAction', true);

const store = useStore();

const currentChat = computed(() => store.getters.getSelectedChat);
const isActive = computed(
  () =>
    currentChat.value?.id &&
    currentChat.value.id === Number(props.conversationId)
);

const activate = async () => {
  const id = Number(props.conversationId);
  if (!id) return;
  let chat = store.getters.getConversationById(id);
  if (!chat) {
    await store.dispatch('getConversation', id);
    chat = store.getters.getConversationById(id);
  }
  if (chat && chat.id !== currentChat.value?.id) {
    await store.dispatch('setActiveChat', { data: chat });
  }
};

onMounted(() => {
  store.dispatch('inboxes/get');
  activate();
});

watch(() => props.conversationId, activate);
</script>

<template>
  <div class="flex flex-col flex-1 min-h-0 bg-n-background">
    <MessagesView v-if="isActive" />
    <div
      v-else
      class="flex items-center justify-center flex-1 gap-2 text-sm text-n-slate-10"
    >
      <span class="i-lucide-loader-circle animate-spin" />
    </div>
  </div>
</template>
